export default "__VITE_ASSET__D2_Oss4S__"